import React from 'react';
import List from '@mui/material/List';
import Collapse from '@mui/material/Collapse';

import Link from './Link';
import {
  NestedList,
} from './styled';

export default function LinkList({ links, nested, open }) {
  const ListComponent = nested ? NestedList : List;

  return (
    <Collapse in={open} timeout="auto" unmountOnExit>
      <ListComponent>
        {links.map(({ path, label, iconComponent, children }, idx) => (
          <Link
            key={idx}
            to={path}
            primary={label}
            {...{ iconComponent, children }}
          />
        ))}
      </ListComponent>
    </Collapse>
  );
}
